import { atom } from "jotai"

export const INIT_DIVISION = {
    divId: null,
    divCode: "",
    divName: "",
    orgId: null,
    deptId: null,
    status: ""
}

export const divisionAtom  = atom(INIT_DIVISION)
